import Box from '@mui/material/Box';
import React from 'react';
import ConfirmationPage from './ConfirmationPage';
import GroupSettings from './GroupSettings';

const ConnectCardSettings = ({ data, onChange }) => {
  return (
    <Box mb={6}>
      <GroupSettings data={data} onChange={onChange} />
      <ConfirmationPage data={data} onInputChange={onChange} />
    </Box>
  );
};

export default ConnectCardSettings;
